/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./scene-switch.vue?vue&type=template&id=4410195f&scoped=true&"
import script from "./scene-switch.vue?vue&type=script&lang=js&"
export * from "./scene-switch.vue?vue&type=script&lang=js&"
import style0 from "./scene-switch.vue?vue&type=style&index=0&id=4410195f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4410195f",
  null
  
)

export default component.exports